<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
  <div class="cards-holder devices-tab">

    <div class="card card2 mRight">
      <app-loader [showLoader]=showLoad></app-loader>
      <div class="graph-div">
        <div class="c-portlet__header">
          <div class="o-stack__cell">
            <h5 class="card-title">Time and Duration of Calls</h5>
            <span class="datatable-icon"  *ngIf="hasData">
              <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank"
                *ngIf="downloadConfiguration && downloadConfiguration.enableDownload">
                <i class="fa fa-download" aria-hidden="true"></i>
              </a>
            </span>
          </div>
        </div>
        <div *ngIf="!hasData" class="no-data-min-ht">
          <div>No Data Found</div>
        </div>
        <div class="calls-graph-area" [hidden]="!hasData" >
          <div class="graph-title">
            <div class="calls-data" [ngClass]="metricsData ?'noCalls-div':''">
              <div class="call-metrics primary-color">
                <div class="item">{{metricsData.answeredCalls | number}} Total Answered Calls</div>
                <div class="item">{{metricsData.avgDuration }} Avg. Duration (HH:MM:SS)</div>
                <div class="item">{{metricsData.missedCalls | number}} Total Missed Calls</div>
              </div>
            </div>

            <div class="graph-filter">
              <div class="filterLabel" [ngClass]="{'answered-inactive': graphFilterDisabled}">
                <span>Show answered calls:</span>
              </div>
              <div [ngClass]="{'graph-filter-option': true, 'answered-inactive': graphFilterDisabled}">
                <select (change)="filterChange($event.target.value)" [disabled]="graphFilterDisabled">
                  <option *ngFor="let item of graphFilterOptions" value="{{item?.id}}" [selected]="item.id == selectedValue">{{item?.name}}</option>
                </select>
              </div>
            </div>

          </div>
          <div *ngIf="graphData.length > 0">
            <div id="chart" #graphArea></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>